<template>
  <div>
    <b-row
      v-if="!isLoading && !viewEdit && !viewAdd"
      class="justify-content-center flex-column align-items-center"
    >
      <div class="d-flex justify-content-between align-items-end w-75 mb-3">
        <h3>Contacts</h3>
        <b-button class="button btn-blue" @click="addNewContact">
          <font-awesome-icon icon="plus" /> <span>{{ "Nouveau contact" }}</span>
        </b-button>
      </div>
      <b-table
        ref="checkbox-table"
        class="agv-table td-middle w-75"
        bordered
        :items="contacts"
        :fields="fieldsContact"
        show-empty
      >
        <template v-slot:cell(name)="row">
          <div class="text-left">
            {{ row.item.lastname + " " + row.item.firstname }}
          </div>
        </template>
        <template #cell(password)="row">
          <appUserPasswordBlock
            :password="row.item.password"
            :show-password="row.item.showPassword"
            @toggleShowPassword="row.item.showPassword = !row.item.showPassword"
          />
        </template>
        <template v-slot:cell(_actions)="row">
          <b-row class="actions text-center">
            <b-col>
              <b-button
                class="btn btn-sm btn-edit tablebutton text-info"
                title="Réinitialiser le mot de passe"
                @click="openModalAGResetUserPassword(row.item.username, 'contact')"
              >
                <font-awesome-icon icon="lock" size="2x" />
              </b-button>
              <b-button
                class="btn btn-sm btn-edit tablebutton"
                title="Modifier le contact"
                @click="editContact(row.item)"
              >
                <font-awesome-icon icon="pen" size="2x" />
              </b-button>
            </b-col>
          </b-row>
        </template>
        <template #empty>
          <span>{{ "Aucune donnée n'a été trouvée..." }}</span>
        </template>
      </b-table>
      <div class="d-flex justify-content-start w-75 mt-3 mb-2">
        <h3>Invités</h3>
      </div>
      <b-table
        ref="checkbox-table"
        class="agv-table td-middle w-75 w-offset-25"
        bordered
        :items="meetingGuests"
        :fields="fieldsMeetingGuest"
        show-empty
      >
        <template #cell(password)="row">
          <appUserPasswordBlock
            :password="row.item.password"
            :show-password="row.item.showPassword"
            @toggleShowPassword="row.item.showPassword = !row.item.showPassword"
          />
        </template>
        <template v-slot:cell(meeting_id)="row">
          <div class="text-left">
            {{ getMeeting(row.item.meeting_id) }}
          </div>
        </template>
        <template v-slot:cell(_actions)="row">
          <b-row class="actions text-center">
            <b-col>
              <b-button
                class="btn btn-sm btn-edit tablebutton text-info"
                title="Réinitialiser le mot de passe"
                @click="openModalAGResetUserPassword(row.item.username, 'meeting-guest')"
              >
                <font-awesome-icon icon="lock" size="2x" />
              </b-button>
              <b-button
                class="btn btn-sm btn-edit tablebutton"
                title="Modifier l'invité de la réunion"
                @click="editMeetingGuest(row.item)"
              >
                <font-awesome-icon icon="pen" size="2x" />
              </b-button>
              <b-button
                class="tablebutton btn-red"
                variant="white"
                title="Supprimer l'invité de la réunion"
                @click="deleteMeetingGuest(row.item)"
              >
                <font-awesome-icon icon="trash-alt" size="2x" />
              </b-button>
            </b-col>
          </b-row>
        </template>
        <template #empty>
          <span>{{ "Aucune donnée n'a été trouvée..." }}</span>
        </template>
      </b-table>
    </b-row>
    <b-row v-if="viewEdit || viewAdd" class="d-flex justify-content-center">
      <contact
        v-if="isContact"
        :building-id="building.id"
        :existent-contact="currentContact"
        @cancel="cancelPressed"
      ></contact>
      <meetingGuest
        v-if="isMeetingGuest"
        :existent-meeting-guest="currentMeetingGuest"
        @cancel="cancelPressed"
      ></meetingGuest>
    </b-row>
    <appLoader v-if="isLoading" />

    <b-modal id="modal-ag-reset-user-password" hide-footer size="lg">
      <template #modal-title>
        <div>Réinitialiser le mot de passe</div>
      </template>
      <modalAGResetUserPassword
        :username="username"
        :user-type="userType"
        @closeModal="closeModalAGResetUserPassword"
        @userPasswordReseted="userPasswordReseted"
      />
    </b-modal>
  </div>
</template>

<script>
import ContactORM from "@/store/orm-axios/models/Contact";
import ContactMW from "@/middlewares/Contact";

import MeetingGuestMW from "@/middlewares/MeetingGuest";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";

import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import contact from "./contact/Contact";
import meetingGuest from "./meeting-guest/MeetingGuest";

import modalAGResetUserPassword from "@/components/modals/AGResetUserPassword";
import appUserPasswordBlock from "@/components/snippets/UserPasswordBlock";

export default {
  components: {
    contact,
    meetingGuest,
    modalAGResetUserPassword,
    appUserPasswordBlock,
  },
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: true,
      viewEdit: false,
      viewAdd: false,
      isContact: false,
      isMeetingGuest: false,
      currentContact: null,
      currentMeetingGuest: null,
      fieldsContact: [
        {
          key: "name",
          label: "Nom",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "username",
          label: "Nom d'utilisateur",
        },
        {
          key: "password",
          label: "Le mot de passe",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
      fieldsMeetingGuest: [
        {
          key: "fullname",
          label: "Nom",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "username",
          label: "Nom d'utilisateur",
        },
        {
          key: "password",
          label: "Le mot de passe",
        },
        {
          key: "meeting_id",
          label: "Reunion",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
      username: "",
      userType: "",
    };
  },
  computed: {
    contacts() {
      var contacts = ContactORM.query().where("building_id", this.building.id).get();

      return contacts.map(c => {
        return {
          ...c,
          showPassword: false,
        };
      });
    },
    meetingGuests() {
      var meetingGuests = MeetingGuestORM.query().get();

      return meetingGuests.map(mg => {
        return {
          ...mg,
          showPassword: false,
        };
      });
    },
    meetings() {
      return MeetingORM.query().get();
    },
  },
  watch: {
    viewAdd(val) {
      this.$emit("hideParentActionButtons", val);
    },
    viewEdit(val) {
      console.log("viewEdit", val);
      this.$emit("hideParentActionButtons", val);
    },
  },
  async created() {
    await ContactMW.FETCH(this.building.id);
    await MeetingGuestMW.GET_BY_BUILDING(this.building.id);
    await MeetingMW.GET_BY_BUILDING(this.building.id);
    this.isLoading = false;
  },
  beforeDestroy() {
    MeetingGuestORM.deleteAll();
  },
  methods: {
    editContact(item) {
      this.viewEdit = true;
      this.isContact = true;
      this.currentContact = item;
    },
    addNewContact() {
      this.viewAdd = true;
      this.isContact = true;
      this.currentContact = null;
    },
    editMeetingGuest(item) {
      this.viewEdit = true;
      this.isMeetingGuest = true;
      this.currentMeetingGuest = item;
    },
    deleteMeetingGuest(item) {
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            MeetingGuestMW.DELETE(item);
          }
        })
        .catch(err => {
          self.$swal(self.alertError());
        });
    },
    getMeeting(meetingId) {
      let meeting = this.meetings.filter(obj => obj.id === meetingId);
      if (meeting) {
        return meeting[0].name;
      } else {
        return "";
      }
    },
    cancelPressed() {
      this.viewAdd = false;
      this.viewEdit = false;
      this.isContact = false;
      this.isMeetingGuest = false;
      this.currentContact = null;
      this.currentMeetingGuest = null;
    },
    openModalAGResetUserPassword(username, userType) {
      this.username = username;
      this.userType = userType;
      this.$bvModal.show("modal-ag-reset-user-password");
    },
    closeModalAGResetUserPassword() {
      this.$bvModal.hide("modal-ag-reset-user-password");
    },
    userPasswordReseted() {
      this.closeModalAGResetUserPassword();
    },
  },
};
</script>
